import axios from "axios";
import { errorMessage, tokenExpired } from "@/api/errorMessages";
import * as api from "@/api/oauth";

export default {
  namespaced: true,
  state: {
    addCommodity: 0,
    requestCompleted: true,
    itemsTableFlag: true,
    recalcTrigger: 0
  },
  getters: {
    showRequestCompleted(state) {
      return state.requestCompleted;
    },
    showItemsTableFlag(state) {
      return state.itemsTableFlag;
    },
    showRecalcTrigger(state) {
      return state.recalcTrigger;
    }
  },
  mutations: {
    addCommodity(state) {
      state.addCommodity += 1;
    },
    setRequestCompleted(state, newRequestCompleted) {
      state.requestCompleted = newRequestCompleted;
    },
    setItemsTableFlag(state, newItemsTableFlag) {
      state.itemsTableFlag = newItemsTableFlag;
    },
    triggerRecalc(state) {
      state.recalcTrigger += 1;
    }
  },
  actions: {
    async addCommodity({ commit }, commodity) {
      try {
        let response = await axios.post(
          process.env.VUE_APP_BACK_ROUTE + `/api/commodity/create/`,
          commodity,
          api.getToken()
        );
        if (response.status === 200) {
          commit("addCommodity");
          return response;
        }
      } catch (err) {
        if (err.response.status === 403) {
          tokenExpired();
        } else if (err.response.status != 200) {
          errorMessage();
        }
        return err.response;
      }
    },

    async updateCommodity({ commit }, info) {
      let validateRequestItemsTable = false;
      try {
        let response = await axios.put(
          process.env.VUE_APP_BACK_ROUTE +
            `/api/commodity/update/${info.commodityId}/`,
          info.payload,
          api.getToken()
        );
        commit("setRequestCompleted", validateRequestItemsTable);
        if (response.status === 200) {
          validateRequestItemsTable = true;
          commit("addCommodity");
          commit("setRequestCompleted", validateRequestItemsTable);
        }
      } catch (err) {
        if (err.response.status === 403) {
          tokenExpired();
        } else if (err.response.status != 200) {
          errorMessage();
        }
        return err.response;
      }
    },

    async getContributions({ commit }, info) {
      try {
        let response = await axios.post(
          process.env.VUE_APP_BACK_ROUTE + `/api/operations/get_contributions/`,
          info,
          api.getToken()
        );
        if (response.status === 200) {
          commit("addCommodity");
          return response;
        }
      } catch (err) {
        if (err.response.status === 403) {
          tokenExpired();
        } else if (err.response.status != 200) {
          errorMessage();
        }
        return err.response;
      }
    },

    async getWeightFromContribution({ commit }, info) {
      try {
        let response = await axios.post(
          process.env.VUE_APP_BACK_ROUTE +
            `/api/operations/get_weights_from_contributions/`,
          info,
          api.getToken()
        );
        if (response.status === 200) {
          commit("addCommodity");
          return response;
        }
      } catch (err) {
        if (err.response.status === 403) {
          tokenExpired();
        } else if (err.response.status != 200) {
          errorMessage();
        }
        return err.response;
      }
    },

    async calculateNmfcClass({ commit }, info) {
      try {
        let response = await axios.post(
          process.env.VUE_APP_BACK_ROUTE + `/api/operations/nmfc_calculator/`,
          info,
          api.getToken()
        );
        if (response.status === 200) {
          commit("addCommodity");
          return response;
        }
      } catch (err) {
        if (err.response.status === 403) {
          tokenExpired();
        } else if (err.response.status != 200) {
          errorMessage();
        }
        return err.response;
      }
    },

    async deleteCommodity({ commit }, commodityId) {
      try {
        let response = await axios.delete(
          process.env.VUE_APP_BACK_ROUTE +
            `/api/commodity/delete/${commodityId}/`,
          api.getToken()
        );
        if (response.status === 200) {
          commit("addCommodity");
        }
      } catch (err) {
        if (err.response.status === 403) {
          tokenExpired();
        } else if (err.response.status != 200) {
          errorMessage();
        }
        return err.response;
      }
    }
  }
};
